import React from 'react';
import DataTable from 'react-data-table-component';
import i18n from '../../../i18n';
import { Modal, Spinner } from 'react-bootstrap';
import { getAllMeetings, getMeetingAttendees, statuses } from '../../../models/meetings';
import { MzadLoader } from '../../helpers/mzadLoader';
import { getLoggedUser } from '../../../state/user';
import { getAllWinners } from '../../../models/auctions';
import { FinishMeeting } from '../meeting/finish_meeting';
import { WinnersMeeting } from '../meeting/winners_list';

const user = getLoggedUser();
let lang = localStorage.getItem('I18N_LANGUAGE');
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      backgroundColor: '#dadada',
      color: '#000000',
    },
  },
};

export class MeetingList extends React.Component {
  constructor() {
    super();
    this.state = {
      winners: [],
      meeting: {},
      groups: [],
      meetingGroups: [],
      ended_groups: [],
      attendees: [],
      add: {},
      meetingID: null,
      signature: null,
      data: {},
      errors: {},
      is_loading: false,
      users: {},
      hideSidebar: false,
      totalRows: 0,
      currentPage: 1,
      input: {
        page: 1,
        limit: 15,
        meeting_status: 'N',
      },
      screen_val: '1',
      edit_screen_val: '1',
      columns: [
        {
          name: 'ID',
          sortable: true,
          wrap: true,
          width: '50px',
          cell: (row) => row.id,
        },
        {
          name: `${i18n.t('total_groups')}`,
          width: '130px',
          cell: (row) => (
            <button
              className="btn btn-outline-dark"
              onClick={(e) => {
                this.viewGroups(row.groups);
              }}
            >
              {row.groups.length}
            </button>
          ),
          sortable: true,
        },
        {
          name: i18n.t('title'),
          cell: (row) => {
            return `${row.title_ar} \r\n${row.title}`;
          },
          sortable: true,
          wrap: true,
        },
        {
          name: `${i18n.t('meeting')} ${i18n.t('number')}`,
          cell: (row) => {
            return `${row.number_ar} \r\n${row.number}`;
          },
        },
        {
          name: `${i18n.t('location')}`,
          cell: (row) => {
            return `${row.location_ar} \r\n${row.location}`;
          },
        },
        {
          name: `${i18n.t('final_approved_officer')}`,
          cell: (row) => {
            return row?.final_approved_officer ? `${row?.final_officer?.name_ar} \r\n${row?.final_officer?.name}` : '';
          },
        },
        {
          name: i18n.t('date'),
          width: '150px',
          cell: (row) => {
            return `${row.date}\r\n${i18n.t('start')}:${row.start_time}\r\n${i18n.t('end')}:${row.end_time}`;
          },
          sortable: true,
        },
        {
          name: i18n.t('status'),
          cell: (row) => statuses[row.status_label],
          sortable: true,
        },
        {
          name: i18n.t('attendees'),
          button: true,
          cell: (row) => (
            <button
              className="btn btn-primary rounded-0"
              onClick={(e) => {
                this.viewAttendees(row.attendees);
              }}
            >
              {i18n.t('attendees')}
            </button>
          ),
        },
        {
          name: i18n.t('action'),
          button: true,
          cell: (row) =>
            row.status !== 'C' &&
            (user.role === 'A' || user.role === 'RS' || user.role === 'O') && (
              <button
                className="btn btn-danger rounded-0"
                onClick={(e) => {
                  this.startMeeting(row);
                }}
              >
                {i18n.t('start')}
              </button>
            ),
        },
      ],
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.triggerReload = this.triggerReload.bind(this);
    this.loadWinners = this.loadWinners.bind(this);
  }

  componentDidMount() {
    let { input } = this.state;
    input.meeting_status = this.props.meeting_status;
    this.setState({ input });
    let qstring = new URLSearchParams(input).toString();
    this.loadAllMeetings(qstring);
  }

  async loadAllMeetings(q) {
    this.setState({ is_loading: true });
    const response = await getAllMeetings(q);
    let users = response.data;
    let meta = response.meta;
    if (response.success) {
      this.setState({ is_loading: false });
      this.setState({ users: users });
      this.setState({ totalRows: meta.total });
    } else {
      this.setState({ is_loading: false });
    }
  }
  viewGroups(groups) {
    this.setState({ group_popup: true, meetingGroups: groups });
  }

  viewAttendees(attendees) {
    this.setState({ attendees_loading: true });
    // const response = await getMeetingAttendees(id);
    // if (response.success) {
    // let data = response.data;
    this.setState({ attendees_popup: true, attendees: attendees });
    this.setState({ attendees_loading: false });
    // }
  }

  async startMeeting(row) {
    const groupId = row.groups?.[0]?.id; // <-- pick the first group id
    this.loadWinners(groupId);
    this.loadWinners(groupId);
    this.setState({ meeting_loading: true, meeting: row });
    this.setState({ meeting_popup: true, attendees: row.attendees, meeting_loading: false });

    // const response = await getMeetingAttendees(row?.id);
    // if (response.success) {
    // let data = response.data;
    this.setState({ meeting_popup: true, attendees: row.attendees });
    this.setState({ meeting_loading: false });
    // }
  }

  handlePageChange = (page) => {
    let input = this.state.input;
    let currentPage = page;
    input['page'] = currentPage;
    this.setState({ currentPage: currentPage });
    this.setState({ input: input });
    let qstring = new URLSearchParams(input).toString();
    this.setState({ query: qstring });
    this.loadAllMeetings(qstring);
  };

  triggerReload() {
    let { input } = this.state;
    let qstring = new URLSearchParams(input).toString();
    this.loadAllMeetings(qstring);
  }

  async loadWinners(group) {
    if (group) {
      this.setState({ winners_loading: true });
      const response = await getAllWinners({ group: group });
      if (response.data) {
        this.setState({ winners: response.data });
        this.setState({ winners_loading: false });
      } else {
        this.setState({ winners_loading: false });
      }
    }
  }

  render() {
    let { users, attendees, attendees_loading, meeting_popup, meeting_loading, meeting, winners } = this.state;
    let { meeting_status } = this.props;
    let meeting_label = {
      N: i18n.t('new'),
      P: i18n.t('pending'),
      C: i18n.t('completed'),
    };
    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div className="card mb-0">
                <div className="card-header d-flex justify-content-between">
                  <div className=" d-flex">
                    <h3 className="card-title">
                      {meeting_label[meeting_status]}&nbsp;{i18n.t('meetings')}
                    </h3>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive ">
                    {this.state.is_loading && (
                      <div className="text-center">
                        <Spinner animation="border" size="lg" />
                      </div>
                    )}

                    {!this.state.is_loading && users.length === 0 && (
                      <div className="alert border border-danger text-danger">{i18n.t('no_data_found')}</div>
                    )}

                    {!this.state.is_loading && users.length > 0 && (
                      <div className="table-wrapper">
                        <DataTable
                          title=""
                          fixedHeader
                          columns={this.state.columns}
                          data={users}
                          customStyles={customStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.totalRows}
                          paginationPerPage={15}
                          paginationDefaultPage={this.state.currentPage}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('meetings'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.handlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal size="lg" show={this.state.attendees_popup} onHide={() => this.setState({ attendees_popup: false })}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">{i18n.t('attendees')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader animation="grow" size="md" loading={attendees_loading} style={{ position: 'relative' }} />
            {!attendees_loading && attendees.length === 0 && (
              <div className="alert alert-danger">{i18n.t('no_data_found')}</div>
            )}
            {!attendees_loading && attendees.length > 0 && (
              <table className="table table-responsive">
                <thead>
                  <tr>
                    <th>{i18n.t('id')}</th>
                    <th>{i18n.t('name')}</th>
                    <th>{i18n.t('approved')}</th>
                    <th>{i18n.t('notes')}</th>
                  </tr>
                </thead>
                <tbody>
                  {attendees.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>
                          <div>{lang === 'ar' ? item?.officer_details?.name_ar : item?.officer_details?.name}</div>
                          <div>
                            <small className="text-muted">{item.officer_details.rank}</small>
                          </div>
                        </td>
                        <td>
                          <span className={`badge bg-${item.approved ? 'success' : 'danger'}`}>
                            {item.approved ? i18n.t('yes') : i18n.t('no')}
                          </span>
                        </td>
                        <td>{item?.notes}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Modal.Body>
        </Modal>

        {/* <Modal size="lg" show={meeting_popup} onHide={() => this.setState({ meeting_popup: false })} fullscreen>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg"><b>{i18n.t('meeting')}</b> </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader animation="grow" size="md" loading={meeting_loading} style={{ position: 'relative' }} />
            <div className="row">
              <div className="col-4">
                <div className="card m-0 border border-1 p-2 bg-light">
                  <h4>
                    {i18n.t('auction_winners')}(
                    {lang === 'ar' ? meeting?.group_info?.group_name_ar : meeting?.group_info?.group_name})
                  </h4>
                  <WinnersMeeting winners={winners} lang={lang} />
                </div>
              </div>

              <FinishMeeting
                attendees={attendees}
                meetingId={meeting.id}
                onFinished={(isFinished) => {
                  if (isFinished) {
                    this.setState({ meeting_popup: false });
                  }
                }}
              />
            </div>
          </Modal.Body>
        </Modal> */}

        {/* <Modal size="lg" show={this.state.group_popup} onHide={() => this.setState({ group_popup: false })}>
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">{i18n.t('groups')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader animation="grow" size="md" style={{ position: 'relative' }} />
            {this.state.meetingGroups.length === 0 && (
              <div className="alert alert-danger">{i18n.t('no_data_found')}</div>
            )}
            {this.state.meetingGroups.length > 0 && (
              <table className="table table-responsive text-center">
                <thead>
                  <tr>
                    <th>{i18n.t('id')}</th>
                    <th>{i18n.t('group_name')}</th>
                    <th>{i18n.t('total_auctions')}</th>
                    <th>{i18n.t('total_bidders')}</th>
                    <th>{i18n.t('total_amount')}</th>
                    <th>{i18n.t('start_date')}</th>
                    <th>{i18n.t('end_date')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.meetingGroups.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>
                          <p>{lang === 'ar' ? item?.group_name_ar : item?.group_name}</p>
                        </td>
                        <td>
                          <p>{item?.auctions.length}</p>
                        </td>
                        <td>
                          <p>{item?.winners_count?.total_bidders ?? '-'}</p>
                        </td>
                        <td>
                          <p>{item?.winner_bid_sum?.total_amount ?? '-'}</p>
                        </td>
                        <td>
                          <p>{item?.start_date}</p>
                        </td>
                        <td>
                          <p>{item?.end_date}</p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Modal.Body>
        </Modal> */}

        <Modal
          size="xl"
          show={meeting_popup}
          onHide={() => this.setState({ meeting_popup: false })}
          fullscreen
          centered
        >
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>
              <i className="bi bi-people-fill me-2"></i>
              {i18n.t("meeting")}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <MzadLoader
              animation="grow"
              size="md"
              loading={meeting_loading}
              style={{ position: "relative" }}
            />

            <div className="row g-3">
              {/* Winners Section */}
              <div className="col-lg-4">
                <div className="card h-100">
                  <div className="card-header bg-light fw-bold">
                    {i18n.t("auction_winners")} 
                  </div>
                  <div className="card-body p-3">
                    <div className="table-responsive" style={{ maxHeight: "350px" }}>
                      <WinnersMeeting winners={winners} lang={lang} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Attendees Section */}
              <div className="col-lg-8">
                <div className="card h-100">
                  <div className="card-header bg-light fw-bold d-flex align-items-center">
                    <i className="bi bi-person-check-fill me-2 text-success"></i>
                    {i18n.t("attendees")}
                  </div>
                  <div className="card-body p-3">
                    <div className="table-responsive" style={{ maxHeight: "350px" }}>
                      <FinishMeeting
                        attendees={attendees}
                        meetingId={meeting.id}
                        onFinished={(isFinished) => {
                          if (isFinished) this.setState({ meeting_popup: false });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-end">
            <button
              className="btn btn-secondary"
              onClick={() => this.setState({ meeting_popup: false })}
            >
              {i18n.t("close")}
            </button>
          </Modal.Footer>
        </Modal>

      </React.Fragment>
    );
  }
}
